import React from "react";
import http from "../../util/api";
import qs from "qs";
import moment from "moment";
import "./Verify.scss";
import img0 from "./imgs/logo1.jpg";
import img1 from "./imgs/SHVO.png";
import img2 from "./imgs/logo1.png";
import { Toast, Button } from "antd-mobile";
import SignatureCanvas from "react-signature-canvas";
import BraftEditor from "braft-editor";
import "braft-editor/dist/index.css";

let timer;
class Verify extends React.Component {
  state = {
    title: "",
    toWrite: "",
    signature: null,
    REC_ID: "",
    showSigPad: false,
    trimmedDataURL: "",
    h: window.innerHeight,
    w: window.innerWidth - 48,
    telephone: "",
    name: "",
    editorState: "",
  };

  async componentDidMount() {
    const search = document.location.search;
    const querystring = search.substring(1);
    let id = qs.parse(querystring).id; //从url中取id
    this.setState({
      id,
    });
    // Toast.loading("登录中，请稍后…");
    this.getToken();
  }
  constructor(props) {
    super(props);
    this.trim = this.trim.bind(this);
  }

  trim = async () => {
    let url = { baseURL: window.liveUrl };
    const { telephone, name, id } = this.state;
    let res;
    if(telephone && name ){
    let obj = {
      name: name,
      telephone: telephone,
      insertID: id,
    };
    let result = await this.getSign();
    if (result) {
      this.props.history.push({
        pathname: "/PatientShowContent",
        search: `name=${name}&telephone=${telephone}`,
      });
    } else {
      try {
        res = await http(url).addRecords({
          resid: 644680002327,
          data: [obj],
        });
        this.props.history.push({
          pathname: "/PatientShowContent",
          search: `name=${name}&telephone=${telephone}`,
        });
      } catch (error) {}
    }
  }else{
    Toast.info('请填写正确信息！')
  }
  };
  getSign = async () => {
    let res;
    const { telephone, name, id } = this.state;
    let url = { baseURL: window.liveUrl };
    try {
      res = await http(url).getTable({
        resid: 644680002327,
        cmswhere: `name = '${name}' and telephone = '${telephone}'`,
      });
      if (res.data.data[0]) {
        return true;
      } else {
        return false;
      }
    } catch (error) {}
  };
  getToken = async () => {
    let res;
    let url = { baseURL: window.liveUrl };
    try {
      res = await http(url).login({
        code: "public",
        password: "123456",
      });
      let str = JSON.stringify(res.data);
      localStorage.setItem("userInfo", str);
    } catch (e) {
      console.log(e.message);
      Toast.fail("登录失败");
    }
  };

  render() {

    return (
      <div className="verify">

        <div className="verify_form">
          <h4>姓名</h4>
          <input
            max="11"
            value={this.state.name}
            onChange={(v) => {
              this.setState({ name: v.target.value });
            }}
          />
          <h4>手机尾号4位</h4>
          <input
            maxlength="4"
            minlength="4"
            type="number"
            value={this.state.telephone}
            onChange={(v) => {
              this.setState({ telephone: v.target.value });
            }}
          />
        </div>

        <div className="imgLine">

        <img src={img0} />
          <img src={img1} />
          <img src={img2} />
        </div>
        <div className="btnLine">
          <Button
            size="small"
            type="primary"
            className="submit"
            onClick={() => {
              this.trim();
            }}
          >
            确定
          </Button>
        </div>
      </div>
    );
  }
}

export default Verify;
